import { Route, RouteConfig } from "vue-router";

export const dashboardRoutes: Array<RouteConfig> = [
  {
    path: "/dashboardusers",
    name: "dashboardusers",
    meta: {
      breadcrumb: [
        {
          text: "Dashboardusers",
        },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ "../../../views/DashboardUsers.vue"
      ),
  },
  {
    path: "/",
    redirect: "/dashboardusers",
  },
];

for (const dashboardRoute of dashboardRoutes) {
  if (!dashboardRoute.meta) {
    dashboardRoute.meta = {};
  }
  dashboardRoute.meta.authRequired = true;
  dashboardRoute.meta.userTypes = ["employee", "nutritionist"];
}
